let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("m9WAb")).then(() => parcelRequire('9GRwk'));